module.exports = __webpack_public_path__ + "img/green-tick.d81eb461.png";